@if (!isLoading) {
  <div class="flex flex-row items-center public-container">
    <div class="flex flex-col gap-10">
      <div class="flex flex-row gap-4">
        <div>
          <mat-icon class="md-37 primary-color">
            {{icon}}
          </mat-icon>
        </div>
        <div class="dcp-h2">{{message}}</div>
      </div>

      <pin-button buttonStyle="filled" buttonId="login" buttonType="button" redirectUrl="/login">LOG IN</pin-button>
    </div>
  </div>
} @else {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
